import { useState, useCallback } from 'react';

const useRecordsUpdater = () => {
  const [latestRecord, setLatestRecord] = useState(null);

  const addRecord = useCallback((record) => {
    setLatestRecord(record);
  }, []);

  return { latestRecord, addRecord, setLatestRecord };
};

export default useRecordsUpdater;
